import { Component, OnInit } from '@angular/core';
import { ApplicationIndexComponent } from '../../application-index/application-index.component';
import { Field } from '../../field';
import { LayoutService } from '../../layout.service';

@Component({
  selector: 'app-input-integer',
  templateUrl: './input-integer.component.html',
  styleUrls: ['./input-integer.component.less']
})
export class InputIntegerComponent extends Field {

  constructor(public layoutService: LayoutService) {
    super(layoutService);
  }

  formatterNumber(value: number): string {
    if (value == null || isNaN(value)) {
      value = 0;
    }

    return `${Number(value).toFixed(0).toString()}`;
  }
}
